import ContactsToolbar from "../../components/ContactsToolbar";
import GroupsTable from "../../components/GroupsTable";
import useContactsData from "../../hooks/useContactsData";
import { useContacts } from "../../contexts/ContactsContext";
import EmptyState from "../../components/EmptyState";
import { Store } from "lucide-react";

const GroupsTab = () => {
  const { selectedShopIds } = useContacts();
  const { items, loading, reload } = useContactsData({ category: "groups" });

  return (
    <div className="flex flex-col h-full">
      <ContactsToolbar
        title="Nhóm Zalo"
        subtitle={`${items.length} nhóm`}
        onReload={reload}
        loading={loading}
      />
      <div className="flex-1 overflow-hidden">
        {selectedShopIds.length === 0 ? (
          <EmptyState
            icon={Store}
            title="Chưa chọn tài khoản Zalo"
            description="Chọn ít nhất 1 tài khoản từ dropdown phía trên để xem nhóm."
          />
        ) : (
          <GroupsTable items={items} loading={loading} />
        )}
      </div>
    </div>
  );
};

export default GroupsTab;
